import { Component, OnInit, Input, Inject } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-ai-activities-page',
  templateUrl: './ai-activities-page.component.html',
  styleUrls: ['./ai-activities-page.component.css']
})
export class AiActivitiesPageComponent implements OnInit {

  @Input() $transition$: any;

  constructor(
    private authService: AuthService,
    @Inject('$state') private $state: any
  ) { }

  ngOnInit() {
  }

  redirectToUrl(stateName: string, reload: boolean) {
    this.$state.go(stateName, {}, { reload: reload });
  }
}
